import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    VisitorIqFilterSettingsFragment as VisitorIqFilterSettings,
    GetVisitorIqFilterSettings as GetVisitorIqFilterSettingsQuery,
} from 'nutshell-graphql-types';

import GET_VISITOR_IQ_FILTER_SETTINGS from '../queries/get-visitor-iq-filter-settings.graphql';

export function useGetVisitorIqFilterSettings(): {
    visitorIqFilterSettings: VisitorIqFilterSettings | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetVisitorIqFilterSettingsQuery, Record<any, any>>(
        GET_VISITOR_IQ_FILTER_SETTINGS,
        {}
    );

    return {
        visitorIqFilterSettings: data ? data.visitorIqFilterSettings : undefined,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
